/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyLevelCompanyJobGlobalGradeMappingService {

    /**
     * Get list of job global grade survey level mappings
     * @returns any Success
     * @throws ApiError
     */
    public static getJobGlobalGradeSurveyLevelMappings({
        requestBody,
    }: {
        requestBody?: {
            planId: number;
            vendorLevelProfileIds?: Array<string>;
            surveyJobLevelIds?: Array<string>;
            companyJobGlobalGradeIds?: Array<number>;
        },
    }): CancelablePromise<Array<{
        planId?: number;
        surveyJobLevelId?: string;
        companyJobGlobalGradeId?: number;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/globalGradeSurveyLevel',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create job mapping
     * @returns any Success
     * @throws ApiError
     */
    public static createJobGlobalGradeSurveyLevelMapping({
        companyJobGlobalGradeId,
        surveyJobLevelId,
        requestBody,
    }: {
        /**
         * Company Job Global Grade ID
         */
        companyJobGlobalGradeId: number,
        /**
         * Survey Job Level ID
         */
        surveyJobLevelId: string,
        requestBody?: {
            /**
             * Plan of company
             */
            planId: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/globalGradeSurveyLevel/{companyJobGlobalGradeId}/{surveyJobLevelId}',
            path: {
                'companyJobGlobalGradeId': companyJobGlobalGradeId,
                'surveyJobLevelId': surveyJobLevelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete job mapping
     * @returns any Success
     * @throws ApiError
     */
    public static removeJobGlobalGradeSurveyLevelMapping({
        companyJobGlobalGradeId,
        surveyJobLevelId,
        requestBody,
    }: {
        /**
         * Company Job Global Grade ID
         */
        companyJobGlobalGradeId: number,
        /**
         * Survey Job Level ID
         */
        surveyJobLevelId: string,
        requestBody?: {
            /**
             * Plan of company
             */
            planId: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mapping/globalGradeSurveyLevel/{companyJobGlobalGradeId}/{surveyJobLevelId}',
            path: {
                'companyJobGlobalGradeId': companyJobGlobalGradeId,
                'surveyJobLevelId': surveyJobLevelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get info about job global grade survey level mappings
     * @returns any Success
     * @throws ApiError
     */
    public static getJobGlobalGradeSurveyLevelMappingsInfo(): CancelablePromise<{
        mappingsInfo: {
            hasGlobalLevelsMapped: boolean;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/globalGradeSurveyLevel/mappingsInfo',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
